import AgentLink from '../components/AgentLink'

export default function formatAgent({ x: value }) {
  return <AgentLink value={value} />
}
